export const LT_LANG = {
  'Type something': 'Įveskite tekstą...',
  Advanced: 'Išplėstinis',
  'About Jodit': 'Apie Jodit',
  'Jodit Editor': 'Jodit redaktorius',
  "Jodit User's Guide": 'Jodit naudotojo vadovas',
  'contains detailed help for using': 'turi išsamią naudojimo informaciją.',
  'For information about the license, please go to our website:':
      'Daugiau informacijos apie licenciją rasite mūsų svetainėje:',
  'Buy full version': 'Įsigyti pilną versiją',
  'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
      'Autorių teisės © XDSoft.net - Chupurnov Valerijus. Visos teisės saugomos.',
  Anchor: 'Inkaras',
  'Open in new tab': 'Atidaryti naujame skirtuke',
  'Open in fullsize': 'Atidaryti visame ekrane',
  'Clear Formatting': 'Pašalinti formatavimą',
  'Fill color or set the text color': 'Užpildymo arba teksto spalva',
  Redo: 'Perdaryti',
  Undo: 'Atšaukti',
  Bold: 'Paryškintas',
  Italic: 'Kursyvas',
  'Insert Unordered List': 'Įterpti neenumeruotą sąrašą',
  'Insert Ordered List': 'Įterpti sunumeruotą sąrašą',
  'Align Center': 'Centruoti',
  'Align Justify': 'Lygiuoti abiem kraštais',
  'Align Left': 'Lygiuoti kairėje',
  'Align Right': 'Lygiuoti dešinėje',
  'Insert Horizontal Line': 'Įterpti horizontalią liniją',
  'Insert Image': 'Įterpti paveikslėlį',
  'Insert file': 'Įterpti failą',
  'Insert youtube/vimeo video': 'Įterpti Youtube/Vimeo vaizdo įrašą',
  'Insert link': 'Įterpti nuorodą',
  'Font size': 'Šrifto dydis',
  'Font family': 'Šrifto šeima',
  'Insert format block': 'Įterpti formato bloką',
  Normal: 'Normalus',
  'Heading 1': 'Antraštė 1',
  'Heading 2': 'Antraštė 2',
  'Heading 3': 'Antraštė 3',
  'Heading 4': 'Antraštė 4',
  Quote: 'Citata',
  Code: 'Kodas',
  Insert: 'Įterpti',
  'Insert table': 'Įterpti lentelę',
  'Decrease Indent': 'Sumažinti įtrauką',
  'Increase Indent': 'Padidinti įtrauką',
  'Select Special Character': 'Pasirinkti specialų simbolį',
  'Insert Special Character': 'Įterpti specialų simbolį',
  'Paint format': 'Nukopijuoti formatą',
  'Change mode': 'Pakeisti režimą',
  Margins: 'Paraštės',
  top: 'viršus',
  right: 'dešinė',
  bottom: 'apačia',
  left: 'kairė',
  Styles: 'Stiliai',
  Classes: 'Klasės',
  Align: 'Lygiuoti',
  Right: 'Dešinė',
  Center: 'Centras',
  Left: 'Kairė',
  '--Not Set--': '--Nenustatyta--',
  Src: 'Šaltinis',
  Title: 'Pavadinimas',
  Alternative: 'Alternatyvus tekstas',
  Filter: 'Filtras',
  Link: 'Nuoroda',
  'Open link in new tab': 'Atidaryti nuorodą naujame skirtuke',
  Image: 'Paveikslėlis',
  file: 'Failas',
  'Image properties': 'Paveikslėlio savybės',
  Cancel: 'Atšaukti',
  Ok: 'Gerai',
  'Your code is similar to HTML. Keep as HTML?':
      'Jūsų kodas panašus į HTML. Palikti kaip HTML?',
  'Paste as HTML': 'Įklijuoti kaip HTML',
  Keep: 'Palikti',
  Clean: 'Išvalyti',
  'Insert as Text': 'Įterpti kaip tekstą',
  'Word Paste Detected': 'Aptiktas Word įklijavimas',
  'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
      'Įklijuotas turinys yra iš Microsoft Word/Excel dokumento. Ar norite išlaikyti formatą ar jį išvalyti?',
  'Insert only Text': 'Įterpti tik tekstą',
  'File Browser': 'Failų naršyklė',
  'Error on load list': 'Klaida kraunant sąrašą',
  'Error on load folders': 'Klaida kraunant aplankus',
  'Are you sure?': 'Ar esate tikras?',
  'Enter Directory name': 'Įveskite katalogo pavadinimą',
  'Create directory': 'Sukurti katalogą',
  'type name': 'įveskite pavadinimą',
  'Drop image': 'Numeskite paveikslėlį',
  'Drop file': 'Numeskite failą',
  'or click': 'arba spustelėkite',
  'Alternative text': 'Alternatyvus tekstas',
  Browse: 'Naršyti',
  Upload: 'Įkelti',
  Background: 'Fonas',
  Text: 'Tekstas',
  Top: 'Viršus',
  Middle: 'Vidurys',
  Bottom: 'Apačia',
  'Insert column before': 'Įterpti stulpelį prieš',
  'Insert column after': 'Įterpti stulpelį po',
  'Insert row above': 'Įterpti eilutę viršuje',
  'Insert row below': 'Įterpti eilutę apačioje',
  'Delete table': 'Ištrinti lentelę',
  'Delete row': 'Ištrinti eilutę',
  'Delete column': 'Ištrinti stulpelį',
  'Empty cell': 'Išvalyti langelį',
  Delete: 'Ištrinti',
  'Strike through': 'Perbraukti',
  Underline: 'Pabraukti',
  Break: 'Lūžis',
  'Search for': 'Ieškoti',
  'Replace with': 'Pakeisti į',
  Replace: 'Pakeisti',
  Edit: 'Redaguoti',
  'Vertical align': 'Vertikalus lygiavimas',
  'Horizontal align': 'Horizontalus lygiavimas',
  'Sort by changed': 'Rikiuoti pagal pakeitimą',
  'Sort by name': 'Rikiuoti pagal pavadinimą',
  'Sort by size': 'Rikiuoti pagal dydį',
  'Add folder': 'Pridėti aplanką',
  Split: 'Padalinti',
  'Split vertical': 'Vertikalus padalijimas',
  'Split horizontal': 'Horizontalus padalijimas',
  Merge: 'Sujungti',
  'Add column': 'Pridėti stulpelį',
  'Add row': 'Pridėti eilutę',
  Border: 'Rėmelis',
  'Embed code': 'Įterpti kodą',
  Update: 'Atnaujinti',
  superscript: 'Viršutinis indeksas',
  subscript: 'Apatinis indeksas',
  'Cut selection': 'Iškirpti pažymėjimą',
  Paste: 'Įklijuoti',
  'Choose Content to Paste': 'Pasirinkite įklijuojamą turinį',
  'Chars: %d': 'Simbolių: %d',
  'Words: %d': 'Žodžių: %d',
  All: 'Viskas',
  'Select %s': 'Pasirinkti: %s',
  'Select all': 'Pažymėti viską',
  source: 'HTML',
  bold: 'paryškintas',
  italic: 'kursyvas',
  brush: 'Šepetys',
  link: 'nuoroda',
  undo: 'atšaukti',
  redo: 'perdaryti',
  table: 'lentelė',
  image: 'paveikslėlis',
  eraser: 'trintukas',
  paragraph: 'Pastraipa',
  fontsize: 'šrifto dydis',
  video: 'vaizdo įrašas',
  font: 'šriftas',
  about: 'apie',
  print: 'spausdinti',
  underline: 'pabraukti',
  strikethrough: 'perbraukti',
  indent: 'įtrauka',
  outdent: 'atitraukti',
  fullsize: 'visas dydis',
  shrink: 'sumažinti',
  hr: 'horizontali linija',
  ul: 'neenumeruotas sąrašas',
  ol: 'enumeruotas sąrašas',
  cut: 'iškirpti',
  selectall: 'pažymėti viską',
  'Open link': 'Atidaryti nuorodą',
  'Edit link': 'Redaguoti nuorodą',
  'No follow': 'Nesekti',
  Unlink: 'Pašalinti nuorodą',
  Eye: 'Peržiūra',
  pencil: 'Redaguoti',
  ' URL': 'URL',
  Reset: 'Atstatyti',
  Save: 'Išsaugoti',
  'Save as ...': 'Išsaugoti kaip...',
  Resize: 'Keisti dydį',
  Crop: 'Apkarpyti',
  Width: 'Plotis',
  Height: 'Aukštis',
  'Keep Aspect Ratio': 'Išlaikyti proporciją',
  Yes: 'Taip',
  No: 'Ne',
  Remove: 'Pašalinti',
  Select: 'Pasirinkti',
  'You can only edit your own images. Download this image on the host?':
      'Galite redaguoti tik savo vaizdus. Atsisiųsti šį paveikslėlį į serverį?',
  'The image has been successfully uploaded to the host!':
      'Paveikslėlis sėkmingai įkeltas į serverį!',
  palette: 'paletė',
  'There are no files': 'Šiame kataloge nėra failų.',
  Rename: 'Pervadinti',
  'Enter new name': 'Įveskite naują pavadinimą',
  preview: 'peržiūra',
  download: 'atsisiųsti',
  'Paste from clipboard': 'Įklijuoti iš iškarpinės',
  "Your browser doesn't support direct access to the clipboard.":
      'Jūsų naršyklė nepalaiko tiesioginės prieigos prie iškarpinės.',
  'Copy selection': 'Kopijuoti pažymėtą',
  copy: 'kopijuoti',
  'Border radius': 'Kraštinės spindulys',
  'Show all': 'Rodyti visus',
  Apply: 'Taikyti',
  'Please fill out this field': 'Prašome užpildyti šį lauką',
  'Please enter a web address': 'Prašome įvesti žiniatinklio adresą',
  Default: 'Numatyta',
  Circle: 'Apskritimas',
  Dot: 'Taškas',
  Quadrate: 'Kvadratas',
  'Lower Alpha': 'Mažosios raidės',
  'Lower Greek': 'Mažosios graikų raidės',
  'Lower Roman': 'Mažosios romėniškos',
  'Upper Alpha': 'Didžiosios raidės',
  'Upper Roman': 'Didžiosios romėniškos',
  Find: 'Rasti',
  'Find Previous': 'Rasti ankstesnį',
  'Find Next': 'Rasti kitą',
  'Insert className': 'Įterpti klasės pavadinimą',
  'Press Alt for custom resizing': 'Spauskite Alt, kad keistumėte dydį rankiniu būdu'
};
